<template>
  <div
    class="report-modal-feedback"
    :class="{ 'report-modal-feedback--active': visible }"
  >
    <div class="report-modal-feedback__wrapper">
      <div class="report-modal-feedback__content">
        <h3>
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.3983 13.7504C16.9297 14.7502 16.2626 16 15.2011 16H1.38364C0.320103 16 -0.343927 14.7483 0.186502 13.7504L7.09533 0.749531C7.62705 -0.25075 8.95882 -0.248937 9.4896 0.749531L16.3983 13.7504ZM8.29246 11.0625C7.56097 11.0625 6.96797 11.7061 6.96797 12.5C6.96797 13.2939 7.56097 13.9375 8.29246 13.9375C9.02395 13.9375 9.61695 13.2939 9.61695 12.5C9.61695 11.7061 9.02395 11.0625 8.29246 11.0625ZM7.03498 5.89544L7.24856 10.1454C7.25855 10.3443 7.41006 10.5 7.59356 10.5H8.99136C9.17486 10.5 9.32637 10.3443 9.33636 10.1454L9.54995 5.89544C9.56075 5.68063 9.40316 5.5 9.20495 5.5H7.37995C7.18173 5.5 7.02418 5.68063 7.03498 5.89544Z"
              fill="#F5A623"
            />
          </svg>
          Nenhum resultado encontrado
        </h3>

        <div class="report-modal-feedback__warning">
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.3983 13.7504C16.9297 14.7502 16.2626 16 15.2011 16H1.38364C0.320103 16 -0.343927 14.7483 0.186502 13.7504L7.09533 0.749531C7.62705 -0.25075 8.95882 -0.248937 9.4896 0.749531L16.3983 13.7504ZM8.29246 11.0625C7.56097 11.0625 6.96797 11.7061 6.96797 12.5C6.96797 13.2939 7.56097 13.9375 8.29246 13.9375C9.02395 13.9375 9.61695 13.2939 9.61695 12.5C9.61695 11.7061 9.02395 11.0625 8.29246 11.0625ZM7.03498 5.89544L7.24856 10.1454C7.25855 10.3443 7.41006 10.5 7.59356 10.5H8.99136C9.17486 10.5 9.32637 10.3443 9.33636 10.1454L9.54995 5.89544C9.56075 5.68063 9.40316 5.5 9.20495 5.5H7.37995C7.18173 5.5 7.02418 5.68063 7.03498 5.89544Z"
              fill="#F5A623"
            />
          </svg>
          <p>Não foi possível gerar o relatório para o período solicitado.</p>
        </div>

        <button
          class="report-modal-feedback__button btn btn-primary btn-regular-size"
          @click="closeModal"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportModalFeedback',
  props: {
    visible: {
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
.report-modal-feedback {
  position: fixed;
  z-index: 1040;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  visibility: hidden;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity ease-in 0.2s;

  &--active {
    opacity: 1;
    visibility: visible;
  }

  &__wrapper {
    display: flex;
    width: 90%;
    max-width: 580px;
    min-height: 244px;
    padding: 32px 80px;
    border-radius: 6px;
    background-color: #fff;
    box-shadow: 6px, 2px, 4px, rgba(0, 0, 0, 0.2);
  }

  &__content {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;

    h3 {
      color: #4a4a4a;
      font-size: 18px;
      font-weight: 500;
    }

    svg {
      margin-right: 10px;

      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        height: 16px;
      }
    }
  }

  &__warning {
    margin-top: 20px;
    background-color: rgba(245, 166, 35, 0.2);
    border-radius: 6px;
    padding: 15px;
    display: flex;

    p {
      flex-shrink: 1;
    }

    svg {
      height: 100%;
      margin-right: 16px;

      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        height: 16px !important;
      }
    }
  }

  &__button {
    width: 139px;
    border-radius: 3px;
    margin: 20px auto 0;
  }
}
</style>
